import { useMemo } from "react";

/**
 * Hook to get the hash parameters from the URL
 *
 * @returns The hash parameters as a URLSearchParams object
 */
export const useHashParams = (): URLSearchParams | null => {
  return useMemo(() => {
    if (typeof window !== "undefined" && window.location?.hash) {
      const hash = window.location.hash.replace(/^#&?/, "");
      return new URLSearchParams(hash);
    }
    return null;
  }, []);
};
